import React from 'react';

import Header from './header';
import slug from '../constants/slug';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import CosoRoute from 'containers/Coso';
import FacilitypermitRoute from 'containers/FacilitypermitContainer';
import FacilityDeviceRoute from 'containers/FacilityDeviceContainer';
import FacilityemissionRoute from 'containers/FacilityemissionContainer';
import FacilityeiaRoute from 'containers/FacilityeiaContainer';
import UserRoute from 'containers/UserContainer';
import FacilityHazarWasteReportRoute from 'containers/FacilityHazarWasteReportContainer';

import InspectionRoute from 'containers/Inspection';
import FacilityAuditRoute from 'containers/FacilityAudit';
import LegalDocumentRoute from 'containers/LegalDocument';
import EnvironmentProtectionWork from 'containers/environment-protection-work';

import FacilityeEnviProtectFeeRoute from 'containers/FacilityeEnviProtectFeeContainer';

import FacilityEnviMonitoringReportRoute from 'containers/FacilityEnviMonitoringReportContainer';

import MapContainer from 'containers/MapContainer';
import MonitoringDataContainer from 'containers/MonitoringDataContainer';
import ReportContainer from 'containers/ReportContainer';
import ManagementContainer from 'containers/ManagementContainer';
import AdminContainer from 'containers/AdminContainer';
import BiodiversityRoute from 'containers/Biodiversity';
// import PageBuilding from 'components/pageBuilding';

import NoMatchRoute from 'containers/NoMatchRoute';
import Login from 'containers/LoginContainer';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';
import { getLookupItem } from '@redux/actions/lookupitemsAction';

@connect(
  (state) => ({
    isLogged: _get(state, 'auth.isLogged', false),
  }),
  { getLookupItem }
)
class MainLayout extends React.Component {
  async componentDidMount() {
    const { isLogged, getLookupItem } = this.props;
    if (!isLogged) return;
    await getLookupItem();
  }

  render() {
    return (
      <Switch>
        <Route
          exact
          key={slug.LOGIN}
          path={slug.LOGIN}
          render={(matchProps) => <Login {...matchProps} />}
        />
        {this.props.isLogged ? <AppRoute /> : <Redirect to={slug.LOGIN} />}
        {/* <AppRoute /> */}
      </Switch>
    );
  }
}

class AppRoute extends React.Component {
  render() {
    return (
      <div id='app'>
        <Header />
        <div
          style={{
            background: '#fff',
            padding: 24,
            margin: 0,
          }}
        >
          <Switch>
            {CosoRoute()}
            {FacilityeiaRoute()}
            {FacilityEnviMonitoringReportRoute()}
            {FacilityeEnviProtectFeeRoute()}
            {InspectionRoute()}
            {FacilityAuditRoute()}
            {FacilitypermitRoute()}
            {FacilityDeviceRoute()}
            {FacilityemissionRoute()}
            {FacilityHazarWasteReportRoute()}
            {UserRoute()}
            {LegalDocumentRoute()}
            {EnvironmentProtectionWork()}
            {BiodiversityRoute()}
            <Route
              exact
              path={slug.MAP.BASE}
              render={(matchProps) => <MapContainer {...matchProps} />}
            />
            <Route
              exact
              path={slug.MONITORING_DATA.BASE}
              render={(matchProps) => (
                <MonitoringDataContainer {...matchProps} />
              )}
            />
            <Route
              exact
              path={slug.MANAGEMENT.LIST}
              render={(matchProps) => <ManagementContainer {...matchProps} />}
            />
            <Route
              exact
              path={slug.ADMIN.LIST}
              render={(matchProps) => <AdminContainer {...matchProps} />}
            />
            <Route
              exact
              path={slug.REPORT.BASE}
              render={(matchProps) => <ReportContainer {...matchProps} />}
            />
            <Route render={(matchProps) => <NoMatchRoute {...matchProps} />} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withRouter(MainLayout);



// WEBPACK FOOTER //
// ./src/layout/index.js